/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotofont3Inputs */

const en_aiflowphotofont3 = /** @type {(inputs: Aiflowphotofont3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font`)
};

const de_aiflowphotofont3 = /** @type {(inputs: Aiflowphotofont3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrift`)
};

/**
* | output |
* | --- |
* | "Font" |
*
* @param {Aiflowphotofont3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotofont3 = /** @type {((inputs?: Aiflowphotofont3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotofont3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotofont3(inputs)
	return de_aiflowphotofont3(inputs)
});
export { aiflowphotofont3 as "aiFlowPhotoFont" }